module.exports = __webpack_public_path__ + "img/hr-curved-rail-vertical-left-top-metals-remnants.013d8700.png";